import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "../App.css";

const API = "https://slimlinehardwarefittings.com/backend";

export default function Blog() {

  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlogs();
  }, []);

  // FETCH BLOGS
  const fetchBlogs = async () => {

    try {
      const res = await axios.get(`${API}/blogs.php`);

      console.log("BLOG API:", res.data);

      const data = Array.isArray(res.data)
        ? res.data
        : res.data.blogs || [];

      setBlogs(data);

    } catch (err) {
      console.log("API ERROR:", err);
      setBlogs([]);

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="blogs-section">

      <h1 className="blog-main-title">
        Latest Blogs
      </h1>

      {/* LOADING */}
      {loading && (
        <p>Loading blogs...</p>
      )}

      {/* NO BLOG */}
      {!loading && blogs.length === 0 && (
        <p>No blogs found</p>
      )}

      {/* BLOG GRID */}
      <div className="blog-grid">

        {blogs.map((blog) => (

          <div
            className="blog-card"
            key={blog.id}
          >

            <img
              src={
                blog.image
                  ? `${API}/uploads/${blog.image}`
                  : "https://via.placeholder.com/300"
              }
              alt={blog.title}
              className="blog-img"
            />

            <div className="blog-content-main">

              <h2>{blog.title}</h2>

              <p>
                {blog.excerpt
                  ? blog.excerpt.slice(0, 100) + "..."
                  : "No description available"}
              </p>

              {/* ✅ FIXED LINK */}
             <Link className="read-btn" to={`/blogs/${blog.slug}`}>
  Read More
</Link>

            </div>

          </div>

        ))}

      </div>

    </div>
  );
}